import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import PropTypes from 'prop-types';

const ModalTemplate = ({ title, body, open, onClose, buttons, text }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 650,
          maxHeight: '90%',
          overflowY: 'hidden',
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: '32px 16px 32px 32px',
          borderRadius: 5,
          display: 'flex',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            top: 0,
            left: 0,
            width: '100%',
            maxHeight: '100%',
            paddingRight: '16px',
            overflowY: 'auto',
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          {text && (
            <Typography variant="p" component="p">
              {text}
            </Typography>
          )}

          {body}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 3,
            }}
          >
            {buttons}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ModalTemplate.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.element,
  buttons: PropTypes.array,
  text: PropTypes.string,
};

export default ModalTemplate;
